import { useEffect } from "react";
import { syncShippingMethod } from "../scripts/shippingMethods";
import { OrderType } from "../../common/constants/OrderType";

export function useSyncShippingMethod(orderType: OrderType) {
  useEffect(() => {
    syncShippingMethod(orderType).then();
  }, [orderType]);
}
